<div class="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
  <div class="max-w-3xl mx-auto">
    <!-- Header Section -->
    <div class="text-center mb-12">
      <h1 class="text-4xl font-bold text-green-800 mb-4">Frequently Asked Questions</h1>
      <p class="text-lg text-gray-600">Find answers to common questions about our tea and services</p>
      @if (!isLoading && !hasError) {
        <button
          (click)="toggleAllFaqs()"
          class="mt-4 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-green-800 hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500">
          {{ areAllExpanded ? 'Collapse All' : 'Expand All' }}
        </button>
      }
    </div>

    <!-- FAQ Section -->
    <div class="space-y-6">
      @if (isLoading) {
        @for (i of [1,2,3]; track i) {
          <div class="bg-white rounded-lg shadow-sm p-6 animate-pulse">
            <div class="h-6 bg-gray-200 rounded w-3/4 mb-4"></div>
            <div class="space-y-2">
              <div class="h-4 bg-gray-200 rounded"></div>
              <div class="h-4 bg-gray-200 rounded w-5/6"></div>
            </div>
          </div>
        }
      }

      @if (!isLoading && hasError) {
        <div class="text-center p-6 bg-red-50 rounded-lg">
          <p class="text-red-600">Unable to load FAQs. Please try again later.</p>
        </div>
      }

      @if (!isLoading && !hasError) {
        @for (faq of faqs; track faq) {
          <div class="bg-white rounded-lg shadow-sm p-6">
            <button (click)="toggleFaq(faq)" class="flex justify-between items-center w-full text-left">
              <h3 class="text-lg font-medium text-gray-900">{{faq.question}}</h3>
              <span class="ml-6 flex-shrink-0">
                <svg class="h-6 w-6 text-gray-500 transform transition-transform"
                  [ngClass]="{'rotate-180': faq.isOpen}"
                  fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
              </span>
            </button>
            <div class="mt-4 text-gray-600 overflow-hidden markdown"
              [@expandCollapse]="faq.isOpen ? 'expanded' : 'collapsed'"
              [innerHTML]="faq.answer | markdown | async"
              >
            </div>
          </div>
        }
      }
    </div>
  </div>
</div>
